(function () {
  'use strict';

  var tagName = 'ln-size-finder';
  if (!window.customElements || window.customElements.get(tagName)) return;

  class LacNamSizeFinder extends HTMLElement {
    connectedCallback() {
      if (this._controller || !window.LacNamFitMath) return;

      this._range = this.querySelector('[data-fit-length]');
      if (!this._range) return;

      if (!this._selection) {
        var initialLength = Number(this._range.value);
        this._selection = {
          cm: Number.isFinite(initialLength) ? initialLength : window.LacNamFitMath.constants.defaultCm,
          unit: 'cm',
          width: 'regular'
        };
      }

      this._controller = new AbortController();
      var options = { signal: this._controller.signal };
      this.addEventListener('input', this._onInput.bind(this), options);
      this.addEventListener('change', this._onInput.bind(this), options);
      this.addEventListener('click', this._onClick.bind(this), options);
      this.addEventListener('keydown', this._onKeyDown.bind(this), options);
      this._render();
    }

    disconnectedCallback() {
      if (this._controller) this._controller.abort();
      this._controller = null;
    }

    _onInput(event) {
      if (event.target !== this._range) return;
      var cm = Number(this._range.value);
      if (!Number.isFinite(cm)) return;
      this._selection.cm = cm;
      this._render();
    }

    _eventButton(event) {
      var target = event.target;
      var button = target && target.closest ? target.closest('button[data-fit-unit], button[data-fit-width]') : null;
      if (!button || !this.contains(button) || button.disabled) return null;
      return button;
    }

    _select(button) {
      if (button.hasAttribute('data-fit-unit')) {
        var unit = button.getAttribute('data-fit-unit');
        if (unit !== 'cm' && unit !== 'in') return;
        this._selection.unit = unit;
      } else {
        var width = button.getAttribute('data-fit-width');
        if (width !== 'regular' && width !== 'wide') return;
        this._selection.width = width;
      }
      this._render();
    }

    _onClick(event) {
      var button = this._eventButton(event);
      if (button) this._select(button);
    }

    _onKeyDown(event) {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      var button = this._eventButton(event);
      if (!button) return;

      var attribute = button.hasAttribute('data-fit-unit') ? 'data-fit-unit' : 'data-fit-width';
      var buttons = Array.from(this.querySelectorAll('button[' + attribute + ']')).filter(function (item) {
        return !item.disabled;
      });
      var index = buttons.indexOf(button);
      var nextIndex;
      if (index < 0 || !buttons.length) return;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % buttons.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + buttons.length) % buttons.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = buttons.length - 1;
      else return; // Native buttons handle Enter and Space activation.

      event.preventDefault();
      this._select(buttons[nextIndex]);
      buttons[nextIndex].focus();
    }

    _setText(selector, text) {
      var node = this.querySelector(selector);
      if (node) node.textContent = text;
    }

    _setTransform(selector, transform) {
      var node = this.querySelector(selector);
      if (node) node.style.transform = transform;
    }

    _renderRadios(attribute, selected) {
      this.querySelectorAll('button[' + attribute + ']').forEach(function (button) {
        var checked = button.getAttribute(attribute) === selected;
        button.setAttribute('aria-checked', String(checked));
        button.tabIndex = checked ? 0 : -1;
      });
    }

    _render() {
      var selection = this._selection;
      var state = window.LacNamFitMath.calculate(selection.cm, selection.unit);
      this._range.value = String(state.lengthCm);
      this._range.style.setProperty('--fit-progress', state.progress + '%');
      this._range.setAttribute('aria-valuetext', state.valueText + (state.unit === 'cm' ? ' xăng-ti-mét' : ' inch'));

      this._setText('[data-fit-value]', state.valueText);
      this._setText('[data-fit-unit-label]', state.unit);
      this._setText('[data-fit-result="us-men"]', state.usMen);
      this._setText('[data-fit-result="us-women"]', state.usWomen);
      this._setText('[data-fit-result="vn"]', state.vn);
      this._setText('[data-fit-result="uk"]', state.uk);
      this._setText('[data-fit-note]', selection.width === 'wide' ? (this.dataset.wideNote || '') : (this.dataset.regularNote || ''));
      this._setText('[data-fit-shop]', (this.dataset.shopLabel || 'Xem sản phẩm') + ' · Size VN ' + state.vn);
      this._setText('[data-fit-marker-text]', state.markerText);

      this._setTransform('[data-fit-marker]', 'translate(' + state.markerX + 'px, 0px)');
      this._setTransform('[data-fit-foot]', state.footTransform);
      this._setTransform('[data-fit-letters]', 'translate(' + state.lettersX + 'px, 0px)');
      var plate = this.querySelector('[data-fit-plate]');
      if (plate) {
        plate.setAttribute('aria-label', 'Mô phỏng bàn chân dài ' + state.valueText + ' ' + state.unit + ', size VN ' + state.vn + '.');
      }

      this._renderRadios('data-fit-unit', selection.unit);
      this._renderRadios('data-fit-width', selection.width);
    }
  }

  LacNamSizeFinder.version = '1.0.0';
  window.customElements.define(tagName, LacNamSizeFinder);
})();
